import api from '../../axiosInstance';  // axios 인스턴스 임포트 (공통 설정 포함)
import { ensureCsrfToken } from '../../utils/csrfUtils';  // CSRF 토큰 확보 함수 임포트

/**
 * 유저 리스트 조회 API 호출 함수 (검색, 필터, 페이징 포함)
 * 
 * @param {Object} params - 검색 및 페이징 관련 파라미터 객체
 * @param {string} params.searchKeyword - 검색 키워드 (기본값: 빈 문자열)
 * @param {string} params.category - 검색 카테고리 (예: '아이디', '이메일', '전체') (기본값: '전체')
 * @param {string} params.status - 승인 상태 필터 (예: '전체', 'PENDING', 'APPROVED') (기본값: '전체')
 * @param {number} params.page - 조회할 페이지 번호 (0부터 시작, 기본값: 0)
 * @param {number} params.size - 페이지당 데이터 개수 (기본값: 10)
 * 
 * @returns {Promise<Object>} - 페이징된 유저 리스트 데이터가 포함된 Promise 반환
 */
export const getAllUserInfo = async ({
  searchKeyword = '',
  category = '전체',
  status = '전체',
  page = 1,
  size = 10000,
} = {}) => {
  console.log('[adminApi] 유저 리스트 조회 페이징 API 호출', { searchKeyword, category, status, page, size });

  // API 요청 파라미터 구성
  const params = {
    searchKeyword,
    category,
    status,
    page,
    size,
  };

  // GET 요청으로 유저 리스트 조회 (검색/필터/페이징 조건 포함)
  const res = await api.get('/api/admin/user/list', { params });

  console.log('[adminApi] 유저 리스트 조회 응답:', res.data);

  // API 응답의 data 객체 내 페이징 포함 유저 리스트 반환
  return res.data.data;
};


export const getUserInfo = async ({
  searchKeyword = '',
  category = '전체',
  status = '전체',
  page = 0,
  size = 4,
} = {}) => {
  console.log('[adminApi] 유저 리스트 조회 페이징 API 호출', { searchKeyword, category, status, page, size });

  // API 요청 파라미터 구성
  const params = {
    searchKeyword,
    category,
    status,
    page,
    size,
  };

  // GET 요청으로 유저 리스트 조회 (검색/필터/페이징 조건 포함)
  const res = await api.get('/api/admin/user/list', { params });

  console.log('[adminApi] 유저 리스트 조회 응답:', res.data);

  // API 응답의 data 객체 내 페이징 포함 유저 리스트 반환
  return res.data.data;
};


/**
 * 미승인 상태인 유저 리스트 조회 함수
 * 
 * @returns {Promise<Array>} - 미승인 유저 리스트 배열 Promise 반환
 */
export const getPendingUsers = async () => {
  console.log('[adminApi] 미승인 유저 리스트 조회 API 호출');

  // 미승인 유저 조회 API 호출
  const res = await api.get('/api/admin/user/pending');

  console.log('[adminApi] 미승인 유저 리스트 조회 응답:', res.data);

  // 응답 데이터에서 미승인 유저 리스트 반환
  return res.data.data;
};


/**
 * 특정 유저 삭제 요청 함수
 * 
 * @param {string} userId - 삭제할 유저의 아이디
 * @param {string} password - 유저 삭제를 위한 본인 확인 비밀번호
 * 
 * @returns {Promise} - axios 삭제 요청 응답 Promise 반환
 */
export const deleteUser = async (userId, password) => {
  console.log(`[adminApi] 유저 삭제 API 호출 - userId: ${userId}`);
  console.log(`[adminApi] 유저 삭제 요청 - userId: ${userId}, password: ${password}`);

  // CSRF 보호를 위해 CSRF 토큰 확보 (요청 전 선처리)
  await ensureCsrfToken();

  // DELETE 요청 시, axios에서 요청 바디를 data 속성에 넣어 전달
  const res = await api.delete(`/api/admin/user/${userId}`, {
    withCredentials: true,      // 쿠키(세션) 포함 요청
    data: { password },         // 삭제 요청 본인 확인 비밀번호 전송
  });

  console.log('[adminApi] 🗑️ 유저 삭제 응답:', res.status);

  // 삭제 요청 응답 객체 그대로 반환
  return res;
};
